export default function saveImage (base64, dirname, callback) {
  callback(null, base64)
}
